module.exports = __webpack_public_path__ + "static/media/dashboard.50dc0cf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/dashboard.svg
// module id = 139
// module chunks = 0